import { useState, useEffect, useCallback } from 'react';
import { authFetch } from '../services/api';

export default function useOnboarding() {
  const [status, setStatus] = useState(null); // null = loading

  useEffect(() => {
    authFetch('/api/user/onboarding')
      .then(r => r.ok ? r.json() : { status: 'not_started' })
      .then(d => setStatus(d.status || 'not_started'))
      .catch(() => setStatus('not_started'));
  }, []);

  const save = useCallback((newStatus) => {
    setStatus(newStatus);
    authFetch('/api/user/onboarding', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status: newStatus }),
    }).catch(() => {});
  }, []);

  return { status, save };
}
